import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { faCircleInfo } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

@Component({
  selector: 'app-hint',
  templateUrl: './hint.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    FontAwesomeModule,
    TooltipModule,
  ],
})
export class HintComponent {
  @Input() public tooltipText: string;

  public readonly faCircleInfo = faCircleInfo;
}
